import { render, staticRenderFns } from "./PurchasePreview.vue?vue&type=template&id=2ea4b584&scoped=true&"
import script from "./PurchasePreview.vue?vue&type=script&lang=ts&"
export * from "./PurchasePreview.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasePreview.vue?vue&type=style&index=0&id=2ea4b584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea4b584",
  null
  
)

export default component.exports